import React from 'react';
import {
  Button,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalSection,
  Paragraph,
} from '@axiom/ui';
import type { UserSearch } from '@axiom/validation';

import { UserSearchesApi } from '../../api/user-searches-api';
import { UserAlertsApi } from '../../api/user-alerts-api';

export const DeleteSavedSearchModal = ({
  onClose,
  savedSearchId,
  type,
}: {
  onClose: () => void;
  savedSearchId: string;
  type: UserSearch['type'];
}) => {
  const handleDeleteSavedSearch = async () => {
    await UserSearchesApi.deleteUserSearch(savedSearchId);
    await UserSearchesApi.refreshUserSearches(type);
    await UserAlertsApi.refreshUserAlerts();
  };

  return (
    <Modal size="confirm">
      <ModalHeader
        name="DELETE_SAVED_SEARCH_MODAL_HEADER"
        onClose={() => {
          onClose();
        }}
      >
        Delete saved search?
      </ModalHeader>
      <ModalSection>
        <Paragraph>
          Deleting this search removes it from saved searches and cancels any
          associated alerts.
        </Paragraph>
      </ModalSection>
      <ModalFooter>
        <Button
          name="NO_BUTTON"
          onClick={() => {
            onClose();
          }}
          variation="outline"
        >
          No
        </Button>
        <Button
          name="YES_BUTTON"
          onClick={async () => {
            await handleDeleteSavedSearch();
            onClose();
          }}
        >
          Yes
        </Button>
      </ModalFooter>
    </Modal>
  );
};
